/* istanbul ignore file */

export const reporter = {
  inform(error, customAttributes = {}) {
    global.newrelic.noticeError(error, customAttributes); // eslint-disable-line @br/laws-of-the-game/no-unauthorized-global-properties
  },
};

export default reporter;
